import { render, staticRenderFns } from "./DepartmentsAutocomplete.vue?vue&type=template&id=9605c8f8"
import script from "./DepartmentsAutocomplete.vue?vue&type=script&lang=js"
export * from "./DepartmentsAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports